import AccountingProviderSalesCodeSelect from './AccountingProviderSalesCodeSelect';

export default AccountingProviderSalesCodeSelect;
